<template>
  <layout-login>
    <div class="login-tab">
      <cube-tab-bar
        v-model="selectedLabel"
        show-slider
      >
        <cube-tab label="1">
          {{ $t('message["1110"]') }}
        </cube-tab>
        <cube-tab label="2">
          {{ $t('message["1509"]') }}
        </cube-tab>
      </cube-tab-bar>
      <cube-tab-panels v-model="selectedLabel">
        <cube-tab-panel label="1">
          <tel-find-pwd @submitForm="subForm" />
        </cube-tab-panel>
        <cube-tab-panel label="2">
          <email-find-pwd @submitForm="subForm" />
        </cube-tab-panel>
      </cube-tab-panels>
    </div>
  </layout-login>
</template>
<script>
import { mapActions } from 'vuex'
import TelFindPwd from './personInfo/TelFindPwd'
import EmailFindPwd from './personInfo/EmailFindPwd'
import LayoutLogin from '@/components/mobile/account/LayoutLogin'
export default {
  components: {
    LayoutLogin,
    TelFindPwd,
    EmailFindPwd
  },
  data () {
    return {
      selectedLabel: '1',
      qwLoginUrl: 'javascript:;',
      gcwLoginUrl: 'javascript:;',
      isReady: false
    }
  },
  async mounted () {
  },
  methods: {
    ...mapActions('account/modify', ['findPwd']),
    async subForm (fields) {
      const chain = await this.findPwd()
      chain.params(fields)
        .onSuccess(res => {
          this.$router.push({ name: 'AccountLogin' })
        })
        .onNetSuccess((res) => {
          // console.log(res.data.message)
          // console.log(res)
          const toast = this.$createToast({
            time: 2000,
            txt: res.data.message || res.data.payload[0].message,
            type: 'txt'
          })
          toast.show()
        })
        .config({ tip: false })
        .fetch()
    }
  }
}
</script>
<style lang="scss" scoped>

.login-tab::v-deep {
  .cube-tab-bar {
    margin-bottom: 20px;
  }
}
 .l-register-link {
    line-height: 23px;
    margin: 20px 0;
    text-align: center;
  }
  .footer {
    bottom: 29px;
    width: 100%;
    text-align: center;
    margin-top: 70px;
    img {
      width: 48px;
      height: 48px;
    }
  }
</style>
